import { SmartfireComponent, smartProps } from "@smartfire/gutenberg-react";
import React from "react";
import "./style.scss";

export default class CapsaTitleMiniature extends SmartfireComponent {
  static smartProps = {
    title: smartProps.string.isRequired,
    bg: smartProps.any.withDefault("bg-white"),
    position: smartProps.any.withDefault("center"),
    type: smartProps.string.withDefault("h2"),
  };

  createTitleSpan(title) {
    const wordArray = title.split(" ");
    const hyphonElement = wordArray.indexOf("-");

    const beforeHyphonElement = wordArray.slice(0, hyphonElement);
    const afterHyphonElement = wordArray.slice(hyphonElement);

    const titleSpanned =
      "<span class='highlight-miniature'>" +
      beforeHyphonElement.join(" ") +
      "</span> <span>" +
      afterHyphonElement.join(" ") +
      "</span>";
    return titleSpanned;
  }

  render() {
    return (
      <div ref={this.elementRef}>
        {this.props.type === "h1" ? (
          <h1
            className={
              "capsa-title bg-" +
              this.props.bg +
              " text-" +
              this.props.text +
              " " +
              (this.props.position ? this.props.position : "center")
            }
          >
            <span
              id={"title-container"}
              className={"highlightColor bg-" + this.props.bg}
              dangerouslySetInnerHTML={{
                __html: this.props.title
                  ? this.createTitleSpan(this.props.title)
                  : "",
              }}
            />
          </h1>
        ) : (
          <h2
            className={
              "capsa-title bg-" +
              this.props.bg +
              " text-" +
              this.props.text +
              " " +
              (this.props.position ? this.props.position : "center")
            }
          >
            <span
              id={"title-container"}
              className={"highlightColor bg-" + this.props.bg}
              dangerouslySetInnerHTML={{
                __html: this.props.title
                  ? this.createTitleSpan(this.props.title)
                  : "",
              }}
            />
          </h2>
        )}
      </div>
    );
  }
}
